/* eslint-disable @typescript-eslint/no-unused-vars */
import { View, Text as PDFText, Link, Image } from '@react-pdf/renderer'

import adotelLogo from '../../assets/images/adotel_logo.jpg'
import styles from './styles/index.styles'

interface FooterProps {
  phone: string
  website: string
}

const Footer = ({ phone, website }: FooterProps) => {
  return (
    <View style={styles.mainDiv}>
      <View style={styles.contactDetails}>
        <View style={styles.itemContainer}>
          <PDFText>Tel</PDFText>
          <PDFText> : </PDFText>
          <PDFText>{phone}</PDFText>
        </View>
        <View style={styles.itemContainer}>
          <PDFText style={styles.emoji}>🌐 </PDFText>
          <PDFText>Website</PDFText>
          <PDFText> : </PDFText>
          <PDFText>{website}</PDFText>
        </View>
      </View>

      <View style={styles.adotelContainer}>
        <PDFText style={styles.adotelText}>Powered By </PDFText>
        <Link src="https://www.adotel.net">
          <View style={styles.adotelImgContainer}>
            <Image source={adotelLogo} style={styles.img} />
          </View>
        </Link>
      </View>
    </View>
  )
}
export default Footer
